// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"b-","reportCardBox":"b-","report-img-wrap":"b_","reportImgWrap":"b_","report-title":"ca","reportTitle":"ca","report-date":"cb","reportDate":"cb"};